<template>
	<div class="pages">
		<!-- Loading state -->
		<div v-if="loading" class="flexbox">
			<div class="loading">加载中...</div>
		</div>

		<!-- Success/Failure state -->
		<template v-else>
			<div class="flexbox">
				<img v-if="faceStatus == '2'" src="../../assets/face.png" />
				<img v-else-if="faceStatus == '3'" src="../../assets/fail.png" />
				<img v-else src="../../assets/err.png" />
			</div>
			<div style="margin-top: 10%; text-align: center">
				<div class="submittext">
					{{ faceStatus == '2' ? "信息采集成功" : "信息采集失败" }}
				</div>
				<div class="countdown-text">将在 {{ countdown }} 秒后自动返回</div>
			</div>
			<button class="button" @click="submitHome">确认</button>
		</template>
	</div>
</template>
<script type="text/javascript" src="https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js"></script>
<script type="text/javascript">
	import {
		isLivenessAuth
	} from "@/api/index";
	var ua = navigator.userAgent.toLowerCase();
	export default {
		data() {
			return {
				loading: true,
				faceStatus: null, // 0-未认证 1-处理中 2-已认证 3-认证失败
				faceData: null,
				countdown: 3, // 倒计时秒数
				timer: null,
				callBackObj: {},
			};
		},

		created() {
			var url = window.location.href; //获取地址栏路径
			var temp1 = url.split("?"); //对url地址进行分割
			var pram = temp1[1];
			var keyValue = pram.split("&");
			var obj = {};
			for (var i = 0; i < keyValue.length; i++) {
				//循环分割挂过后的地址
				var item = keyValue[i].split("=");
				var key = item[0];
				var value = item[1];
				obj[key] = value;
			}
			this.params = obj;
			// Call API and handle response
			isLivenessAuth(obj)
				.then((res) => {
					this.faceData = res.data;
					this.faceStatus = res.data && res.data.faceStatus;
				})
				.catch((err) => {
					console.error("Face recognition API error:", err);
					this.faceStatus = '4'; // Show as failed
				})
				.finally(() => {
					this.loading = false;
					// 开始倒计时
					this.startCountdown();
				});
		},
		methods: {
			startCountdown() {
				this.timer = setInterval(() => {
					this.countdown--;
					if (this.countdown <= 0) {
						clearInterval(this.timer);
						this.submitHome();
					}
				}, 1000);
			},
			submitHome() {
				if (this.timer) {
					clearInterval(this.timer);
				}
				if (this.params.businessCode == 'FeeBackCashoutPersonal') {
					this.$uni.redirectTo({
						url: "/pages/personal/rechargeCashback/cashback",
					});
					return
				}
				if (this.faceStatus == '2') {
					this.$uni.redirectTo({
						url: "/pages/gongge/wallet/withdrawal",
					});
				} else {
					this.$uni.redirectTo({
						url: "/pages/gongge/wallet/wallet",
					});
				}
			},
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer);
			}
		},
	};
</script>
<style lang="scss">
	.pages {
		height: 100%;
		width: 100%;
		flex-wrap: nowrap;
		overflow: hidden;
	}

	.flexbox {
		width: 100%;
		height: 100px;
		background: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 10%;

		img {
			width: 80px;
			align-items: center;
			justify-content: center;
			margin-top: 20%;
		}
	}

	.submittext {
		font-size: 16px;
		font-weight: bold;
	}

	.riytext {
		font-size: 12px;
		font-weight: 400;
		color: #757880;
		margin-top: 1%;
	}

	.button {
		color: #fff;
		width: 95%;
		height: 45px;
		margin-left: 2.5%;
		margin-top: 15%;
		background: linear-gradient(107deg, #f42a2a 0%, #c02e2e 100%);
		border-radius: 28px;
		opacity: 1;
		font-size: 18px;
		line-height: 45px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: 500;
		border: 0;
	}

	.loading {
		font-size: 16px;
		color: #333;
		margin-top: 20%;
	}

	.countdown-text {
		font-size: 14px;
		color: #999;
		margin-top: 10px;
	}
</style>